import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { EditMilestoneError, Identifiable, Milestone } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  error: EditMilestoneError;
  editMilestone(request: Boundaries["editMilestone"]["request"]): void;
}

function useMilestoneEdition(milestone: Identifiable<Milestone>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isMilestoneEditionRequestPending(milestone),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isMilestoneEditionRequestSuccess(milestone),
    ),
    isRequestFailure: useSelector(() =>
      selector.isMilestoneEditionRequestFailure(milestone),
    ),
    error: useSelector(() => selector.getMilestoneError(milestone)),
    editMilestone: core.editMilestone,
  };
}

export { useMilestoneEdition };
